import { trigger, transition, style, animate } from '@angular/animations';
import { Component } from '@angular/core';

@Component({
    selector: 'diana-sidenav',
    templateUrl: 'sidenav.component.html',
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ width: 0, opacity: 0 }),
                animate('0.2s ease-out', style({ width: 300, opacity: 1 }))
            ]),
            transition(':leave', [
                style({ width: 300, opacity: 1 }),
                animate('0.2s ease-in', style({ width: 0, opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class SidenavComponent {
  constructor() {}

  isHidden = false;

  onToggleHide() {
    this.isHidden = !this.isHidden;
  }
}
